import lifecycle from 'common/LifecycleEvents/module'

export default lifecycle
